export default __webpack_public_path__ + "static/media/_DSC0507-thumb.a0cd958c.jpg";